'use strict';
//PWC-NOA-315 Computop
var computop = require('computop/components/cleave');

computop.serializeData = function (form) {
    var serializedArray = form.serializeArray();

    serializedArray.forEach(function (item) {
        if (item.name.indexOf('creditdirect_cardNumber') > -1 && $('#creditDirectCardNumber').length > 0) {
            item.value = $('#creditDirectCardNumber').data('cleave').getRawValue();
        } else if (item.name.indexOf('cardNumber') > -1 && $('#cardNumber').length > 0) {
            item.value = $('#cardNumber').data('cleave').getRawValue();
        }
    });

    return $.param(serializedArray);
};

module.exports = computop;
